var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentageBadgeDob = function SvgPercentageBadgeDob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.813 25.188c-1.15-1.15-.388-3.563-.975-4.976C5.25 18.8 3 17.563 3 16c0-1.563 2.225-2.75 2.838-4.213.612-1.462-.176-3.825.974-4.975 1.15-1.15 3.563-.387 4.975-.974C13.2 5.25 14.438 3 16 3c1.563 0 2.75 2.225 4.212 2.838 1.463.612 3.826-.176 4.976.974s.387 3.563.975 4.975C26.75 13.2 29 14.438 29 16c0 1.563-2.225 2.75-2.837 4.212-.613 1.463.174 3.826-.976 4.976s-3.562.387-4.975.975C18.8 26.75 17.563 29 16 29c-1.563 0-2.75-2.225-4.213-2.837-1.462-.613-3.825.174-4.975-.976ZM20.96 10.886l-10 10",
    stroke: "#C2C5CB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.96 13.886a2 2 0 1 0 .001-4 2 2 0 0 0 0 4ZM19.963 21.886a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    stroke: "#C2C5CB",
    strokeMiterlimit: 10
  })));
};
export default SvgPercentageBadgeDob;